import {uniq} from 'lodash-es';

import {TAisDocInterfaceFieldsRaw, TAisDocRegisterFieldsRaw} from 'store/slices/ais-slice/ais-slice-api';

import {
    IAisDocRegisterField,
    IAisDocRegisterFilter,
    IAisDocRegisterFields,
    TAisSliceState,
    IAisDocInterfaceFields,
    IAisDocInterfaceFilter,
    IAisDocInterfaceField,
} from './ais-slice-types';

export const getMappingIdsByDocumentId = (state: TAisSliceState, id: number) => {
    const documentsByTaxEntities = state.registerDocumentsByTax.ids.map(
        documentId => state.registerDocumentsByTax.entities[documentId],
    );

    const mappingIdsToUpdate = uniq(documentsByTaxEntities
        .filter(entity => entity?.id === id)
        .map(entity => entity?.mappingId)
        .filter(v => !!v)) as number[];

    return mappingIdsToUpdate;
};

export const convertRawAisDocRegistersFields = (rawFields: TAisDocRegisterFieldsRaw): IAisDocRegisterFields => {
    const filters: IAisDocRegisterFilter[] = [];
    const columns: IAisDocRegisterField[] = [];

    rawFields
        ?.filter(f => f.isParam || f.display)
        ?.sort((a, b) => a.columnOrdinal - b.columnOrdinal)
        ?.forEach(rf => {
            if (rf.display) {
                columns.push({
                    id: rf.id,
                    columnOrdinal: rf.columnOrdinal,
                    label: rf.userName,
                    type: rf.fieldType,
                    fieldKey: rf.field,
                });
            }

            if (rf.isParam) {
                filters.push({
                    id: rf.id,
                    columnOrdinal: rf.columnOrdinal,
                    label: rf.userName,
                    type: rf.paramType,
                    fieldKey: rf.field,
                    referenceUrl: rf.paramLov,
                    isRequired: rf.paramRequired,
                });
            }
        });

    return {
        columns,
        filters,
    };
};

export const convertRawAisDocInterfaceFields = (rawFields: TAisDocInterfaceFieldsRaw): IAisDocInterfaceFields => {
    const filters: IAisDocInterfaceFilter[] = [];
    const columns: IAisDocInterfaceField[] = [];

    rawFields
        ?.filter(f => f.isParam || f.display)
        ?.sort((a, b) => a.columnOrdinal - b.columnOrdinal)
        ?.forEach(rf => {
            if (rf.display) {
                columns.push({
                    id: rf.id,
                    columnOrdinal: rf.columnOrdinal,
                    label: rf.userName,
                    type: rf.fieldType,
                    fieldKey: rf.field,
                });
            }

            if (rf.isParam) {
                filters.push({
                    id: rf.id,
                    columnOrdinal: rf.columnOrdinal,
                    label: rf.userName,
                    type: rf.paramType,
                    fieldKey: rf.field,
                    referenceUrl: rf.paramLov,
                    isRequired: rf.paramRequired,
                });
            }
        });

    return {
        columns,
        filters,
    };
};
